import loadable from "@loadable/component";
import { useParams } from "react-router";
import CreateIcon from "../../Icons/CreateIcon";
import APIS from "../../constant/Endpoint";
import useGetHook from "../../customHooks/useGetHook";
import usePatchHook from "../../customHooks/usePatchHook";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const EditServiceTypeComponent = loadable(
  () => import("../../components/ServiceType/EditServiceType")
);
const EditServiceType = () => {
  const { id } = useParams();

  const { refetch } = useGetHook({
    queryKey: ["service-type"],
    url: `${APIS.SERVICE_TYPE}${id}/`,
    params: {},
  });

  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["service-type"],
    navigateURL: "/service-type",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.SERVICE_TYPE}${id}/`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Edit Service Type
        </span>
      </div>
      <EditServiceTypeComponent
        isLoading={isPatchLoading}
        handleEdit={handleEdit}
        refetch={refetch}
      />
    </>
  );
};
export default EditServiceType;
